import { IPublicClientApplication } from "@azure/msal-browser";
import { authenticateOnScope, checkValidResponse, scopeApi } from "./common";
import { authenticateChat } from "./chatApi";

//export const loadTableExport = async (instance: IPublicClientApplication, tableName: string) => {
//    const tokenResponse = await authenticateOnScope(instance, scopeApi);
//    const response = await fetch('/app/getTableExport/' + tableName, {
//        method: 'GET',
//        headers: new Headers({
//            'Authorization': 'Bearer ' + tokenResponse.accessToken,
//            'Content-Type': 'application/json'
//        })
//    });
//    await checkValidResponse(response, "getTableExport");
//    const content = await response.blob();
//    download('export.csv', content);
//};

export const assignAppsForUsers = async (instance: IPublicClientApplication, userList: string) => {
    const tokenResponse = await authenticateOnScope(instance, scopeApi);
    const response = await fetch('/app/assignAppsForUsers', {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'Bearer ' + tokenResponse.accessToken,
            'Content-Type': 'text/plain'
        }),
        body: userList
    });
    await checkValidResponse(response, "assignAppsForUsers");
    const data = await response.json();
    return data;
};

export const executeQuery = async (instance: IPublicClientApplication, queryText: string) => {
    const tokenResponse = await authenticateOnScope(instance, scopeApi);
    const response = await fetch('/app/executeQuery', {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'Bearer ' + tokenResponse.accessToken,
            'Content-Type': 'text/plain'
        }),
        body: queryText
    });
    await checkValidResponse(response, "executeQuery");
    const data = await response.json();
    return data;
};

//export const loadTablesMetadata = async (instance: IPublicClientApplication) => {
//    const tokenResponse = await authenticateOnScope(instance, scopeApi);
//    const response = await fetch('/app/getTablesMetadata', {
//        method: 'GET',
//        headers: new Headers({
//            'Authorization': 'Bearer ' + tokenResponse.accessToken,
//            'Content-Type': 'application/json'
//        })
//    });
//    await checkValidResponse(response, "getTablesMetadata");
//    const content = await response.blob();
//    download('export.csv', content);
//};

export const getAppsReadyToMigrate = async (instance: IPublicClientApplication) => {
    const tokenResponse = await authenticateOnScope(instance, scopeApi);
    const response = await fetch('/app/getAppsReadyToMigrate', {
        method: 'GET',
        headers: new Headers({
            'Authorization': 'Bearer ' + tokenResponse.accessToken,
            'Content-Type': 'application/json'
        })
    });
    await checkValidResponse(response, "getAppsReadyToMigrate");
    const data = await response.json();
    return data;
};

export function download(
    fileName: string,
    data: string | ArrayBuffer | ArrayBufferView | Blob,
    mime = "text/plain",
    bom?: string | Uint8Array,
) {
    const blobData = bom === undefined ? [data] : [bom, data]
    const blob = new Blob(blobData, { type: mime })
    const a = document.createElement("a")

    a.download = fileName
    a.href = URL.createObjectURL(blob)
    a.click()
    setTimeout(() => {
        URL.revokeObjectURL(a.href)
        a.remove()
    }, 200)
};

export interface UserRoleItem {
    pseudoId: string | null;
    id: number | null;
    territory: string | null;
    role: string | null;
    userEmail: string | null;
    userName: string | null;
    lastUpdateTime: Date | null;
    isTerritoryRelated: boolean | null;
    wasTerritoryRelated: boolean | null;
};

export const loadUserRoles = async (instance: IPublicClientApplication): Promise<UserRoleItem[]> => {
    const tokenResponse = await authenticateOnScope(instance, scopeApi);
    const response = await fetch('/roles/getUserRoleList', {
        method: 'GET',
        headers: new Headers({
            'Authorization': 'Bearer ' + tokenResponse.accessToken,
            'Content-Type': 'application/json'
        })
    });
    await checkValidResponse(response, "getUserRoleList");
    const data = await response.json();
    return data;
};

export const addUserRole = async (instance: IPublicClientApplication, userRole: UserRoleItem): Promise<UserRoleItem> => {
    const activeAccount = instance.getActiveAccount();
    const tokenResponse = await authenticateChat(instance);
    const messageObj = JSON.stringify(userRole);
    const response = await fetch('/roles/addUserRole', {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'Bearer ' + tokenResponse.accessToken,
            'xct-user-context': activeAccount.idToken,
            'Content-Type': 'application/json'
        }),
        body: messageObj
    });
    await checkValidResponse(response, "addUserRole");
    const data = await response.json();
    return data;
};

export const deleteUserRole = async (instance: IPublicClientApplication, userRole: UserRoleItem): Promise<void> => {
    const activeAccount = instance.getActiveAccount();
    const tokenResponse = await authenticateChat(instance);
    const messageObj = JSON.stringify(userRole);
    const response = await fetch('/roles/deleteUserRole', {
        method: 'DELETE',
        headers: new Headers({
            'Authorization': 'Bearer ' + tokenResponse.accessToken,
            'xct-user-context': activeAccount.idToken,
            'Content-Type': 'application/json'
        }),
        body: messageObj
    });
    await checkValidResponse(response, "deleteUserRole");
};


export const updateUserRole = async (instance: IPublicClientApplication, userRole: UserRoleItem): Promise<UserRoleItem> => {
    const activeAccount = instance.getActiveAccount();
    const tokenResponse = await authenticateChat(instance);
    const messageObj = JSON.stringify(userRole);
    const response = await fetch('/roles/updateUserRole', {
        method: 'PATCH',
        headers: new Headers({
            'Authorization': 'Bearer ' + tokenResponse.accessToken,
            'xct-user-context': activeAccount.idToken,
            'Content-Type': 'application/json'
        }),
        body: messageObj
    });
    await checkValidResponse(response, "updateUserRole");
    const data = await response.json();
    return data;
};

export const syncChatUserRoles = async (instance: IPublicClientApplication, limit: string): Promise<void> => {
    const activeAccount = instance.getActiveAccount();
    const tokenResponse = await authenticateChat(instance);
    const response = await fetch('/roles/syncChatUserRoles', {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'Bearer ' + tokenResponse.accessToken,
            'xct-user-context': activeAccount.idToken,
            'Content-Type': 'application/json'
        }),
        body: limit
    });
    await checkValidResponse(response, "syncChatUserRoles");
};

export const checkIfTerritoryRelated = (role: string | null): boolean => {
    return role === 'Delivery Manager' || role === 'Territory CISO Leader' || role === 'Territory CIO Leader' || role === 'Territory Project Manager';
}

export const actAs = async (instance: IPublicClientApplication, id: number) => {
    const tokenResponse = await authenticateOnScope(instance, scopeApi);
    const response = await fetch('/roles/actAs', {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'Bearer ' + tokenResponse.accessToken,
            'Content-Type': 'text/plain'
        }),
        body: id.toString()
    });
    await checkValidResponse(response, "actAs");
    const data = await response.json();
    return data;
};

export const resetMe = async (instance: IPublicClientApplication) => {
    const tokenResponse = await authenticateOnScope(instance, scopeApi);
    const response = await fetch('/roles/resetMe', {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'Bearer ' + tokenResponse.accessToken,
            'Content-Type': 'text/plain'
        })
    });
    await checkValidResponse(response, "resetMe");
    const data = await response.json();
    return data;
};

export const mapUserRole = async (source: UserRoleItem | null, destination: UserRoleItem | null): Promise<void> => {
    if (destination == null || source == null) {
        return;
    }
    destination.id = source.id;
    destination.pseudoId = source.pseudoId;
    destination.territory = source.territory;
    destination.role = source.role;
    destination.userEmail = source.userEmail;
    destination.userName = source.userName;
    destination.lastUpdateTime = source.lastUpdateTime;
};

export const optionsRoles = ['Admin', 'Project manager', 'App Owner', 'Senior Executive', 'Delivery Manager', 'Territory CISO Leader', 'Territory CIO Leader', 'Territory Project Manager', 'Migration Team'];